import { Typography, Box, styled } from '@mui/material';

export const Container = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 16;
  margin-top: 14px;
  text-align: center;
  color: #616161;
`;
